export default "__VITE_ASSET__74e49cc3__"